import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { UserRequest } from '../models/Request/user-request';

@Injectable({ providedIn: 'root' })
export class UserService {

    // public rows: any;
    // public onListChanged: BehaviorSubject<any>;
   
  constructor(private httpClient: HttpClient) {
    // Set the defaults
    // this.onListChanged = new BehaviorSubject({});    
  } 

  /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  // resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
  //   return new Promise<void>((resolve, reject) => {
  //     Promise.all([this.getDataTableRows()]).then(() => {
  //       resolve();
  //     }, reject);
  //   });
  // }

  /**
   * Get rows
   */
  // getDataTableRows(): Promise<any[]> {
  //   return new Promise((resolve, reject) => {
  //     this.httpClient.get(`${environment.apiUrl}/superuser/superuseruser`).subscribe((response: any) => {
  //       this.rows = response;
  //       this.onListChanged.next(this.rows);
  //       resolve(this.rows);
  //     }, reject);
  //   });
  // }

  //Ritorna oggetti User con tutte le colonne della tabella utenti del db
  getAll() {
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/superuseruser`);          
  }

  getSizeAll() {
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/superuseruser/size`);          
  }
  // return this.httpClient.get<any>(`${environment.apiUrl}/superuseruser`)
  //     .toPromise()
  //     .then(res => res.data as Customer[])
  //     .then(data => data);
  

  insert(user: UserRequest) {   
    return this.httpClient.post<any>(`${environment.apiUrl}/superuser/superuseruser`, user);
  }

  delete(id: string) {   
    return this.httpClient.delete<any>(`${environment.apiUrl}/superuser/superuseruser/${id}`);
  }

  //Ritorna un oggetto User ridotto alcune informazioni della tabella User ed i Ruoli 
  getById(id: string) {    
    return this.httpClient.get<any>(`${environment.apiUrl}/superuser/superuseruser/${id}`);          
  }

  update(user: UserRequest) {   
    return this.httpClient.put<any>(`${environment.apiUrl}/superuser/superuseruser`, user);
  }

}